import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	archiveModalTitle: {
		id: 'issue-archival-modal.archive-modal-title',
		defaultMessage: 'You’re about to archive this issue',
		description: 'Heading of the archive modal',
	},
	archiveModalDescription: {
		id: 'issue-archival-modal.archive-modal-description',
		defaultMessage:
			"This issue and any subtasks will be archived. You won't be able to edit them, and they will no longer appear in this project. <br></br><br></br>" +
			'You can restore this issue from  <b>Archived issues</b>.',
		description:
			'Informs that the issue will be archived and will become uneditable after archiving. Also informs that it will also disappear from this project.',
	},
	archiveModalDescriptionLOne: {
		id: 'issue-archival-modal.archive-modal-description-l-one',
		defaultMessage:
			"This issue will be archived. You won't be able to edit it, and it will no longer appear in this project. <br></br><br></br>" +
			'You can restore this issue from  <b>Archived issues</b>.',
		description:
			'Informs that the issue will be archived and will become uneditable after archiving. Also informs that it will also disappear from this project.',
	},
	issueArchiveButton: {
		id: 'issue-archival-modal.issue-archive-button',
		defaultMessage: 'Archive',
		description: 'Text shown to archive issue',
	},
	closeArchiveModalButton: {
		id: 'issue-archival-modal.close-archive-modal-button',
		defaultMessage: 'Cancel',
		description: 'Text shown to close the issue-archive modal',
	},
	issueArchivalErrorFlagTitle: {
		id: 'issue-archival-modal.issue-archival-error-flag-title',
		defaultMessage: 'We couldn’t archive the issue {issueKey}. Wait a few moments, then try again.',
		description: 'Header content of the issue archival error flag',
	},
	issueArchivalSuccessFlagTitle: {
		id: 'issue-archival-modal.issue-archival-success-flag-title',
		defaultMessage: "We've archived the issue {issueKey}.",
		description: 'Header content of the issue archival success flag',
	},
	issueArchivalSuccessFlagActionViewInArchive: {
		id: 'issue-archival-modal.issue-archival-success-flag-action-view-in-archive',
		defaultMessage: 'View all archived issues',
		description: 'Text to show the link of the issue archives page',
	},
	issueArchivalSuccessFlagActionViewInArchiveIssueTermRefresh: {
		id: 'issue-archival-modal.issue-archival-success-flag-action-view-in-archive-issue-term-refresh',
		defaultMessage: 'View all archived work items',
		description: 'Text to show the link of the work items archives page',
	},
	issueArchivalSuccessFlagActionViewIssue: {
		id: 'issue-archival-modal.issue-archival-success-flag-action-view-issue',
		defaultMessage: 'View issue',
		description: 'Text to show the link of the archived issue page',
	},
	archiveModalTitleIssueTermRefresh: {
		id: 'issue-archival-modal.archive-modal-title-issue-term-refresh',
		defaultMessage: 'You’re about to archive this work item',
		description: 'Heading of the archive modal',
	},
	archiveModalDescriptionIssueTermRefresh: {
		id: 'issue-archival-modal.archive-modal-description-issue-term-refresh',
		defaultMessage:
			"This work item and any subtasks will be archived. You won't be able to edit them, and they will no longer appear in this project. <br></br><br></br>" +
			'You can restore this work item from  <b>Archives</b>.',
		description:
			'Informs that the issue will be archived and will become uneditable after archiving. Also informs that it will also disappear from this project.',
	},
	archiveModalDescriptionLOneIssueTermRefresh: {
		id: 'issue-archival-modal.archive-modal-description-l-one-issue-term-refresh',
		defaultMessage:
			"This work item will be archived. You won't be able to edit it, and it will no longer appear in this project. <br></br><br></br>" +
			'You can restore this work item from  <b>Archives</b>.',
		description:
			'Informs that the issue will be archived and will become uneditable after archiving. Also informs that it will also disappear from this project.',
	},
	issueArchivalErrorFlagTitleIssueTermRefresh: {
		id: 'issue-archival-modal.issue-archival-error-flag-title-issue-term-refresh',
		defaultMessage:
			'Something went wrong at our end. We couldn’t archive the work item ({issueKey}). Refresh and try again.',
		description: 'Header content of the issue archival error flag',
	},
	issueArchivalSuccessFlagTitleIssueTermRefresh: {
		id: 'issue-archival-modal.issue-archival-success-flag-title-issue-term-refresh',
		defaultMessage: 'The work item ({issueKey}) has been archived.',
		description: 'Header content of the issue archival success flag',
	},
	issueArchivalSuccessFlagActionViewIssueIssueTermRefresh: {
		id: 'issue-archival-modal.issue-archival-success-flag-action-view-issue-issue-term-refresh',
		defaultMessage: 'View work item',
		description: 'Text to show the link of the archived issue page',
	},
});
